export class BuildTypeMessage {
  cartridgeRequired: boolean
  name: string

  constructor(cartridgeRequired: boolean, name: string) {
    this.cartridgeRequired = cartridgeRequired
    this.name = name
  }
}
  